import React, { useCallback, useEffect, useState } from 'react'
import { Badge, Button, Card, Form, Table } from '@themesberg/react-bootstrap'
import { getMuaChungSetting, updateMuaChungAllowSamePlayMethod, updateMuaChungMaxOpenGroupsPerGame, updateMuaChungUserExpireDays, updateMuaChungUserMinContributePercent, updateShowMuaChung } from '../../../../controller/api/muaChungSetting'
import { useCookies } from 'react-cookie'

export const MuaChungToggle = ({ compact = false }) => {

  const [cookies] = useCookies(['lottmekong'])

  const [loaded, setLoaded] = useState(true)

  const [showMuaChung, setShowMuaChung] = useState(1)
  const [daysInput, setDaysInput] = useState('14')
  const [savingDays, setSavingDays] = useState(false)
  const [daysError, setDaysError] = useState('')
  const [minPercentInput, setMinPercentInput] = useState('')
  const [savingMinPercent, setSavingMinPercent] = useState(false)
  const [minPercentError, setMinPercentError] = useState('')
  const [allowSamePlayMethod, setAllowSamePlayMethod] = useState(1)
  const [savingAllowSame, setSavingAllowSame] = useState(false)
  const [maxGroupsInput, setMaxGroupsInput] = useState('0')
  const [savingMaxGroups, setSavingMaxGroups] = useState(false)
  const [maxGroupsError, setMaxGroupsError] = useState('')

  const getAllFunc = useCallback(async () => {
    setLoaded(false)
    const resp = await getMuaChungSetting(cookies.lottmekong)
    setShowMuaChung(resp.showMuaChung)
    setDaysInput(String(resp.userExpireDays ?? 14))
    setMinPercentInput(resp.userMinContributePercent >= 1 ? String(resp.userMinContributePercent) : '')
    setAllowSamePlayMethod(resp.allowSamePlayMethod ? 1 : 0)
    setMaxGroupsInput(String(resp.maxOpenGroupsPerGame ?? 0))
    setLoaded(true)
  }, [cookies.lottmekong])

  useEffect(() => {
    getAllFunc()
  }, [])

  const onToggle = async () => {
    setLoaded(false)
    const newValue = showMuaChung ? 0 : 1
    const resp = await updateShowMuaChung(cookies.lottmekong, newValue)
    if (resp) {
      setShowMuaChung(resp.showMuaChung)
    }
    setLoaded(true)
  }

  const onSaveDays = async () => {
    const days = parseInt(daysInput, 10)
    if (!Number.isFinite(days) || days < 1 || days > 365) {
      setDaysError('Nhập số ngày từ 1 đến 365')
      return
    }
    setDaysError('')
    setSavingDays(true)
    const resp = await updateMuaChungUserExpireDays(cookies.lottmekong, days)
    if (resp && resp.error) {
      setDaysError(resp.message || 'Không lưu được số ngày')
    } else if (resp && resp.userExpireDays) {
      setDaysInput(String(resp.userExpireDays))
    } else {
      setDaysError('Không lưu được số ngày')
    }
    setSavingDays(false)
  }

  const onSaveMinPercent = async () => {
    const trimmed = minPercentInput.trim()
    const percent = trimmed === '' ? 0 : parseInt(trimmed, 10)
    if (!Number.isFinite(percent) || percent < 0 || percent > 100) {
      setMinPercentError('Nhập từ 1 đến 100, hoặc để trống / 0 nếu không giới hạn')
      return
    }
    setMinPercentError('')
    setSavingMinPercent(true)
    const resp = await updateMuaChungUserMinContributePercent(cookies.lottmekong, percent)
    if (resp && resp.error) {
      setMinPercentError(resp.message || 'Không lưu được mức góp tối thiểu')
    } else if (resp && resp.status === 'success') {
      setMinPercentInput(resp.userMinContributePercent >= 1 ? String(resp.userMinContributePercent) : '')
    } else {
      setMinPercentError('Không lưu được mức góp tối thiểu')
    }
    setSavingMinPercent(false)
  }

  const onToggleAllowSame = async () => {
    setSavingAllowSame(true)
    const next = allowSamePlayMethod ? 0 : 1
    const resp = await updateMuaChungAllowSamePlayMethod(cookies.lottmekong, next)
    if (resp && resp.status === 'success') {
      setAllowSamePlayMethod(resp.allowSamePlayMethod ? 1 : 0)
    }
    setSavingAllowSame(false)
  }

  const onSaveMaxGroups = async () => {
    const trimmed = maxGroupsInput.trim()
    const max = trimmed === '' ? 0 : parseInt(trimmed, 10)
    if (!Number.isFinite(max) || max < 0 || max > 1000) {
      setMaxGroupsError('Nhập số nguyên từ 0 đến 1000. 0 là không giới hạn')
      return
    }
    setMaxGroupsError('')
    setSavingMaxGroups(true)
    const resp = await updateMuaChungMaxOpenGroupsPerGame(cookies.lottmekong, max)
    if (resp && resp.error) {
      setMaxGroupsError(resp.message || 'Không lưu được trần nhóm')
    } else if (resp && resp.status === 'success') {
      setMaxGroupsInput(String(resp.maxOpenGroupsPerGame ?? 0))
    } else {
      setMaxGroupsError('Không lưu được trần nhóm')
    }
    setSavingMaxGroups(false)
  }

  const allowSameField = (
    <div className="mt-3">
      <Form.Label className="small mb-1">Cho trùng cách chơi</Form.Label>
      <div className="small text-muted mb-1">Bật thì nhiều nhóm đang mở được cùng một game và cùng một cách chơi</div>
      <div className="d-flex justify-content-between align-items-center">
        <span className={allowSamePlayMethod ? 'text-success' : 'text-danger'}>
          {allowSamePlayMethod ? 'Đang cho phép' : 'Đang chặn'}
        </span>
        <Button
          variant={allowSamePlayMethod ? 'outline-danger' : 'outline-success'}
          size="sm"
          onClick={onToggleAllowSame}
          disabled={!loaded || savingAllowSame}
        >
          {savingAllowSame ? 'Đang lưu...' : (allowSamePlayMethod ? 'Chặn trùng' : 'Cho trùng')}
        </Button>
      </div>
    </div>
  )

  const maxGroupsField = (
    <div className="mt-3">
      <Form.Label className="small mb-1">Số nhóm đang mở tối đa mỗi game</Form.Label>
      <div className="small text-muted mb-1">0 là không giới hạn. Tính nhóm status đang góp</div>
      <div className="d-flex gap-2">
        <Form.Control
          type="number"
          min={0}
          max={1000}
          value={maxGroupsInput}
          disabled={!loaded || savingMaxGroups}
          onChange={(e) => {
            setMaxGroupsInput(e.target.value)
            setMaxGroupsError('')
          }}
        />
        <Button
          variant="primary"
          size="sm"
          onClick={onSaveMaxGroups}
          disabled={!loaded || savingMaxGroups}
        >
          {savingMaxGroups ? 'Đang lưu...' : 'Lưu'}
        </Button>
      </div>
      {maxGroupsError ? <div className="small text-danger mt-1">{maxGroupsError}</div> : null}
    </div>
  )

  const minContributeField = (
    <div className="mt-3">
      <Form.Label className="small mb-1">Mức góp tối thiểu khi user tạo nhóm (%)</Form.Label>
      <div className="small text-muted mb-1">Để trống hoặc 0 nếu không giới hạn</div>
      <div className="d-flex gap-2">
        <Form.Control
          type="number"
          min={0}
          max={100}
          value={minPercentInput}
          disabled={!loaded || savingMinPercent}
          onChange={(e) => {
            setMinPercentInput(e.target.value)
            setMinPercentError('')
          }}
        />
        <Button
          variant="primary"
          size="sm"
          onClick={onSaveMinPercent}
          disabled={!loaded || savingMinPercent}
        >
          {savingMinPercent ? 'Đang lưu...' : 'Lưu'}
        </Button>
      </div>
      {minPercentError ? <div className="small text-danger mt-1">{minPercentError}</div> : null}
    </div>
  )

  const expireDaysField = (
    <div className="mt-3">
      <Form.Label className="small mb-1">Thời hạn nhóm do user tạo (ngày)</Form.Label>
      <div className="d-flex gap-2">
        <Form.Control
          type="number"
          min={1}
          max={365}
          value={daysInput}
          disabled={!loaded || savingDays}
          onChange={(e) => {
            setDaysInput(e.target.value)
            setDaysError('')
          }}
        />
        <Button
          variant="primary"
          size="sm"
          onClick={onSaveDays}
          disabled={!loaded || savingDays}
        >
          {savingDays ? 'Đang lưu...' : 'Lưu'}
        </Button>
      </div>
      {daysError ? <div className="small text-danger mt-1">{daysError}</div> : null}
    </div>
  )

  if (compact) {
    return (
      <Card border="light" className="shadow-sm h-100">
        <Card.Header>
          <h6 className="mb-0">Ẩn / hiện mua chung</h6>
          <div className="small text-muted mt-1">Nút Mua chung trên ứng dụng khách</div>
        </Card.Header>
        <Card.Body className="d-flex flex-column justify-content-center">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <span className="text-muted">Trạng thái</span>
            <Badge bg={showMuaChung ? 'success' : 'danger'}>
              {!loaded ? 'Đang cập nhật...' : (showMuaChung ? 'Đang hiện' : 'Đang ẩn')}
            </Badge>
          </div>
          <Button
            variant={showMuaChung ? 'outline-danger' : 'outline-success'}
            size="sm"
            onClick={onToggle}
            disabled={!loaded}
          >
            {showMuaChung ? 'Ẩn nút Mua chung' : 'Hiện nút Mua chung'}
          </Button>
          {expireDaysField}
          {minContributeField}
          {allowSameField}
          {maxGroupsField}
        </Card.Body>
      </Card>
    )
  }

  return (
    <Table responsive className="align-items-center table-bordered table-hover mt-4">
      <thead className='text-center'>
        <tr>
          <th scope="col" style={{ width: '50%' }}>Nút Mua chung trên Client</th>
          <th scope="col">TRẠNG THÁI</th>
          <th scope="col">THAO TÁC</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="text-center"><b>Hiển thị nút "Mua chung"</b></td>
          <td className={"text-center " + (showMuaChung ? 'text-success' : 'text-danger')}>
            <h5>{!loaded ? 'Đang cập nhật...' : (showMuaChung ? 'Đang hiện' : 'Đang ẩn')}</h5>
          </td>
          <td className="text-center">
            {showMuaChung ?
              <Button variant="danger" size="lg" onClick={onToggle} disabled={!loaded}>Ẩn</Button>
              :
              <Button variant="success" size="lg" onClick={onToggle} disabled={!loaded}>Hiện</Button>
            }
          </td>
        </tr>
        <tr>
          <td className="text-center"><b>Thời hạn nhóm do user tạo</b></td>
          <td colSpan={2}>{expireDaysField}</td>
        </tr>
        <tr>
          <td className="text-center"><b>Mức góp tối thiểu khi user tạo nhóm</b></td>
          <td colSpan={2}>{minContributeField}</td>
        </tr>
        <tr>
          <td className="text-center"><b>Cho trùng cách chơi</b></td>
          <td colSpan={2}>{allowSameField}</td>
        </tr>
        <tr>
          <td className="text-center"><b>Số nhóm đang mở tối đa mỗi game</b></td>
          <td colSpan={2}>{maxGroupsField}</td>
        </tr>
      </tbody>
    </Table>
  )
}
